module.exports = __webpack_public_path__ + "fonts/Pretendard-ExtraBold.6957848e.woff";